import {Injectable, TemplateRef} from '@angular/core';
import {MxReportViewCustomizerEvent} from './mx-report-view-customizer-event';

export interface ReportViewFilterActionService {
}

@Injectable()
export class MxReportViewFilterActionsService implements ReportViewFilterActionService {

    private _filterButtonsTemplate: TemplateRef<any>;

    get filterButtonsTemplate(): TemplateRef<any> {
        return this._filterButtonsTemplate;
    }

    constructor() {
    }

    public setUp(event: MxReportViewCustomizerEvent): void {
        this._filterButtonsTemplate = event.filterButtonsTemplate;
    }

}
